import React, { ReactNode } from 'react';
import { firebase } from './firebase';
import { getRemoteConfig, fetchAndActivate, getAll } from 'firebase/remote-config';
import logger from 'util/logger';
import FlagsContext from './FlagsContext';

const remoteConfig = getRemoteConfig(firebase);

interface FlagsProviderProps {
  defaults: {
    [key: string]: string | number | boolean;
  };
  children: ReactNode;
}

const FlagsProvider = ({ defaults, children }: FlagsProviderProps): JSX.Element => {
  const [flags, setFlags] = React.useState(defaults);

  React.useEffect(() => {
    remoteConfig.defaultConfig = defaults;

    fetchAndActivate(remoteConfig)
      .then((activated) => {
        if (!activated) return getAll(remoteConfig);
      })
      .then((remoteFlags) => {
        const newFlags = {
          ...flags,
        };

        for (const [key, config] of Object.entries(remoteFlags)) {
          newFlags[key] = config.asBoolean();
        }

        setFlags(newFlags);
      })
      .catch((error) => logger.error(error));
  }, []);

  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>;
};

export default FlagsProvider;
